import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smooth-scrolls to the element matching the URL hash whenever the location changes.
 * Mount once at the top of <App />. Polls briefly to wait for the target element to
 * render (handy when the target lives lower on the page and is lazy/anim-mounted).
 */
export default function ScrollToHash() {
    const { hash, pathname } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = hash.replace("#", "");
        let attempts = 0;
        const maxAttempts = 30; // ~1.5s at 50ms each

        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
            attempts += 1;
            if (attempts < maxAttempts) {
                setTimeout(tryScroll, 50);
            }
        };

        // Defer one frame so the new page mounts first
        const t = setTimeout(tryScroll, 50);
        return () => clearTimeout(t);
    }, [hash, pathname]);

    return null;
}
